import {
  CREATE_ORGANISATION_SUCCESS,
  FETCH_ORGANISATION_IMPORT_SUCCESS, FETCH_ORGANISATION_SPARE_IMPORT_SUCCESS,
  FETCH_ORGANISATION_SUCCESS,
  GET_ORGANISATION_SUCCESS,
  SAVE_ORGANISATION_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  importData: [],
  spareImportData: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ORGANISATION_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ORGANISATION_SUCCESS: {
      const query = {...state.query};
      if(query && Object.keys(query).length) {
        query.pagination.total = action.count;
      }
      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ORGANISATION_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ORGANISATION_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_ORGANISATION_IMPORT_SUCCESS: {
      return {
        ...state,
        importData: action.data,
      }
    }

    case FETCH_ORGANISATION_SPARE_IMPORT_SUCCESS: {
      return {
        ...state,
        spareImportData: action.data,
      }
    }


    default:
      return state;
  }
}
